<template>
  <div class="search">
    <!-- <div class="locate"><img src="../assets/img/locate.png" alt="">上海</div> -->
    <input type="text" :value="value" @input="$emit('input',$event.target.value)" :placeholder="placeholderText">
    <span @click="query" class="search-btn"><img src="../assets/img/search.png" alt=""></span>
    <!-- <span class="mike"><img src="../assets/img/mike.png" alt=""></span> -->
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholderText: {
      type: String,
      default: '搜索服务、事项'
    }
  },
  methods: {
    query () {
      this.$emit('query')
    }
  }
}
</script>

<style lang="less" scoped>
.search {
  display: flex;
  height: 1.24rem /* 62/50 */;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px;
  background-color: rgba(255,255,255,.3);
  padding: 0 .44rem /* 22/50 */;
  .locate {
    display: flex;
    align-items: center;
    font-size: .52rem /* 26/50 */;
    line-height: .6rem /* 30/50 */;
    border-right: .04rem /* 2/50 */ solid #fff;
    color:  rgba(255,255,255,1);
    padding-right: .44rem /* 22/50 */;
    img {
      width: .44rem /* 22/50 */;
      margin-right: .2rem /* 10/50 */;
    }
  }
  input {
    flex: 1;
    height: 1.24rem /* 62/50 */;
    font-size: .48rem /* 24/50 */;
    color: rgba(255,255,255,1);
    background-color: transparent;
    padding: 0 .2rem /* 10/50 */;
  }
  .search-btn {
    width: .7rem;
    margin:0 .24rem 0;
    padding: 0.3rem 0;
  }
  .mike {
    width: .4rem /* 20/50 */;
    height: .56rem /* 28/50 */;
  }
}
input::-webkit-input-placeholder{
    color:rgba(255,255,255,1);
}
input::-moz-placeholder{   /* Mozilla Firefox 19+ */
    color:rgba(255,255,255,1);
}
input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
    color:rgba(255,255,255,1);
}
input:-ms-input-placeholder{  /* Internet Explorer 10-11 */
    color:rgba(255,255,255,1);
}
</style>
